import styled from "styled-components";
import { Box } from "@mui/material";
import { Button, FormField
} from "src/components";
import ArrowDownSignToNavigate from "src/img/arrow-down-sign-to-navigate.svg";
    
export const InputField = styled(FormField)`
    border: 1px solid #000000;
    border-radius: 8px;
    background: #FFF;
    font-size: 0.875rem;
    height: 2.4375rem;
    width: 100%;
    padding: 0.625rem 1rem;
    box-sizing: border-box;
    max-width: 18.875rem;
    text-align: left;
`;

export const StyledButton = styled(Button)`
    border-radius: 0.4375rem !important;
    height: 2.3125rem;
    line-height: 100%;
    font-size: 0.875rem;
`;

export const AssignmentCard = styled(Box)`
    width: 100%;
    min-width: 0;
    background: #F9FAFC 0% 0% no-repeat padding-box;
    border: 1px solid #DBE5ED;
    opacity: 1;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    overflow: visible;
    padding: 1rem;
`;

export const UserBox = styled(Box)`
    width: 190px;
    height: 45px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 5px #0000001A;
    border: 1px solid #E0E0E0;
    border-radius: 15px;
    opacity: 1;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #000000;
`;

export const UserIconContainer = styled(Box)`
    width: 30px;
    height: 30px;
    background: #D6D6D6 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 2px solid #FFFFFF;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
`;

export const InputSelector = styled.select`
    height: 2.4375rem !important;
    width: ${p => p.width || "12.5rem !important"};
    box-shadow: 0px 3px 6px #00000029;
    font-size: 14px !important;
    border-radius: 7px;
    border: 1px solid #DBE5ED;
    padding-left: 1em;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 500;
    background-color: #fff;
    background-image: url(${ArrowDownSignToNavigate});
    background-repeat: no-repeat;
    background-position-x: 97%;
    background-position-y: 50%;
    appearance: none;
    color: #000000;
`;


export const SearchBar = styled.input`
    border: 1px solid #DBE5ED;
    height: 2.5rem;
    font-family: SofiaPro;
    font-size: 0.875rem;
    border-radius: 0.5rem;
    background-color: #FFF;
    outline: none;
    width: 100%;
    text-align: left;
    padding: 0 1.25rem;
    box-sizing: border-box;

    ::placeholder {
        color: #AFBBC6;
        text-align: left;
        font-family: Manrope;
        font-weight: 500;
        font-size: 0.875rem;
    }
`;

export const AllUserToggler = styled(Box)`
    width: 234px;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #DBE5ED;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
`;

export const FlexRow = styled.div`
    display: flex;
    gap: 1rem;
    width: 100%;
    margin-bottom: 20px;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
`;

export const UsersListContainer = styled.div`
    width: 100%;
    max-height: 24rem;
    overflow-y: auto;
    overflow-x: auto;

    ::-webkit-scrollbar {
        width: 0.375rem;
        height: 0.375rem; /* for horizontal scrollbar */
    }
    ::-webkit-scrollbar-thumb {
        background-color: #DBE5ED;
        border-radius: 0.375rem;
    }
`;

export const Table = styled.table`
    width: 100%;
    min-width: 760px;
    border-collapse: collapse;
    border: 1px solid #DBE5ED;
    table-layout: auto;
`;

export const TH = styled.th`
    padding: 0.5rem 1rem;
    background: transparent;
    text-align: left;
    border: 1px solid #DBE5ED;
    color: #4B5155;
    height: 40px;
    font-weight: 500;
    white-space: nowrap; /* prevent wrapping */
`;

export const TD = styled.td`
    padding: 0.5rem 1rem;
    text-align: left;
    background: #FFFF;
        border: 1px solid #DBE5ED;
        height: 35px;
    vertical-align: middle;
    color: #000000;
    font-weight: 500;
    white-space: nowrap; /* prevent wrapping */
`;

export const Row = styled.tr``;

export const CircleCheckbox = styled.div`
    width: 26px;
    height: 26px;
    background: ${(props) => props.bgColor || "#fff"};
    border: 1px solid #000;
    border-radius: 50%;
    margin: 0 auto;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CheckImage = styled.img`
    width: 26px;
    height: 26px;
`;
